// extracted by mini-css-extract-plugin
export default {"link":"QuickSearch__link--slots-aOIG4","image":"QuickSearch__image--slots-HIQEK","image-container":"QuickSearch__image-container--slots-EhBFP"};